module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US",
      "xml:lang": "en-US"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD1#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("January")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD2#_idTextAnchor003"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("February")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD3#_idTextAnchor004"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("March")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD4#_idTextAnchor005"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("April")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD5#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("May")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD6#_idTextAnchor007"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("June")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD7#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("July")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD8#_idTextAnchor009"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("August")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD9#_idTextAnchor010"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("September")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD10#_idTextAnchor011"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("October")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD11#_idTextAnchor012"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("November")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD12#_idTextAnchor013"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("December")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD12#_idTextAnchor014"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("Bonus Day")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-centered-ital ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/YAAD13#_idTextAnchor015"
    }
  }, [_c('span', {
    staticClass: "small-caps"
  }, [_vm._v("Recommended Reading")])])]), _vm._v(" "), _c('div', {
    staticClass: "x15"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    staticClass: "i100",
    attrs: {
      "alt": "black cat",
      "src": "image/3.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01f3b010","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 69
// module chunks = 0